import { render, staticRenderFns } from "./RegistrarDatos.vue?vue&type=template&id=398d4a86&scoped=true"
import script from "./RegistrarDatos.vue?vue&type=script&lang=js"
export * from "./RegistrarDatos.vue?vue&type=script&lang=js"
import style0 from "./RegistrarDatos.vue?vue&type=style&index=0&id=398d4a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398d4a86",
  null
  
)

export default component.exports